let authCode  = [];

const global_data = {
    authCode: authCode
}
export  {global_data};